
/* ORDER */
export const GET_ORDER_LISTING = "GET_ORDER_LISTING";
export const GET_ORDER_LISTING_SUCCESS = "GET_ORDER_LISTING_SUCCESS";
export const GET_ORDER_LISTING_FAIL = "GET_ORDER_LISTING_FAIL";

export const GET_ORDER_DETAILS = "GET_ORDER_DETAILS";
export const GET_ORDER_DETAILS_SUCCESS = "GET_ORDER_DETAILS_SUCCESS";
export const GET_ORDER_DETAILS_FAIL = "GET_ORDER_DETAILS_FAIL";

export const ADD_ORDER = "ADD_ORDER";
export const ADD_ORDER_SUCCESS = "ADD_ORDER_SUCCESS";
export const ADD_ORDER_FAIL = "ADD_ORDER_FAIL";

export const UPDATE_ORDER = "UPDATE_ORDER";
export const UPDATE_ORDER_SUCCESS = "UPDATE_ORDER_SUCCESS";
export const UPDATE_ORDER_FAIL = "UPDATE_ORDER_FAIL";

export const DELETE_ORDER = "DELETE_ORDER";
export const DELETE_ORDER_SUCCESS = "DELETE_ORDER_SUCCESS";
export const DELETE_ORDER_FAIL = "DELETE_ORDER_FAIL";

export const INSERT_LOG_ORDER = "INSERT_LOG_ORDER";
export const INSERT_LOG_ORDER_SUCCESS = "INSERT_LOG_ORDER_SUCCESS";
export const INSERT_LOG_ORDER_FAIL = "INSERT_LOG_ORDER_FAIL";

export const UPDATE_CUSTOMER_DETAILS = "UPDATE_CUSTOMER_DETAILS";
export const UPDATE_CUSTOMER_DETAILS_SUCCESS = "UPDATE_CUSTOMER_DETAILS_SUCCESS";
export const UPDATE_CUSTOMER_DETAILS_FAIL = "UPDATE_CUSTOMER_DETAILS_FAIL";

export const UPDATE_SHIPPING_DETAILS = "UPDATE_SHIPPING_DETAILS";
export const UPDATE_SHIPPING_DETAILS_SUCCESS = "UPDATE_SHIPPING_DETAILS_SUCCESS";
export const UPDATE_SHIPPING_DETAILS_FAIL = "UPDATE_SHIPPING_DETAILS_FAIL";

export const UPDATE_BILLING_DETAILS = "UPDATE_BILLING_DETAILS";
export const UPDATE_BILLING_DETAILS_SUCCESS = "UPDATE_BILLING_DETAILS_SUCCESS";
export const UPDATE_BILLING_DETAILS_FAIL = "UPDATE_BILLING_DETAILS_FAIL";

export const MARK_AS_PAID = "MARK_AS_PAID";
export const MARK_AS_PAID_SUCCESS = "MARK_AS_PAID_SUCCESS";
export const MARK_AS_PAID_FAIL = "MARK_AS_PAID_FAIL";

export const MARK_AS_CLOSED = "MARK_AS_CLOSED";
export const MARK_AS_CLOSED_SUCCESS = "MARK_AS_CLOSED_SUCCESS";
export const MARK_AS_CLOSED_FAIL = "MARK_AS_CLOSED_FAIL";

export const UPDATE_STATUS = "UPDATE_STATUS";
export const UPDATE_STATUS_SUCCESS = "UPDATE_STATUS_SUCCESS";
export const UPDATE_STATUS_FAIL = "UPDATE_STATUS_FAIL";

export const UPDATE_COURIER = "UPDATE_COURIER";
export const UPDATE_COURIER_SUCCESS = "UPDATE_COURIER_SUCCESS";
export const UPDATE_COURIER_FAIL = "UPDATE_COURIER_FAIL";

export const REVERT_ORDER_STATUS = "REVERT_ORDER_STATUS";
export const REVERT_ORDER_STATUS_SUCCESS = "REVERT_ORDER_STATUS_SUCCESS";
export const REVERT_ORDER_STATUS_FAIL = "REVERT_ORDER_STATUS_FAIL";

export const DOWNLOAD_INVOICE = "DOWNLOAD_INVOICE";
export const DOWNLOAD_INVOICE_SUCCESS = "DOWNLOAD_INVOICE_SUCCESS";
export const DOWNLOAD_INVOICE_FAIL = "DOWNLOAD_INVOICE_FAIL";

export const EXPORT_ORDER = "EXPORT_ORDER";
export const EXPORT_ORDER_SUCCESS = "EXPORT_ORDER_SUCCESS";
export const EXPORT_ORDER_FAIL = "EXPORT_ORDER_FAIL";

export const RESET_ORDER_STATE = 'RESET_ORDER_STATE';
export const RESET_ORDER_ATTACHMENT_STATE = 'RESET_ORDER_ATTACHMENT_STATE';